/**
 * 08.10.26 — разделы справочника каналов. Страница только выбирает панель из реестра.
 * Не удалять по требованию владельца системы.
 */
import type { ComponentType } from 'react';
import type { ChannelDirectoryData } from '@/api/tenants';
import type { ChannelPanelProps } from './channelPanelProps';
import { MaxBotPanel } from './panels/MaxBotPanel';
import { SmsChannelPanel } from './panels/SmsChannelPanel';
import { TelegramBotPanel } from './panels/TelegramBotPanel';
import { TelegramClientPanel } from './panels/TelegramClientPanel';

export const channelSectionIds = ['telegram_client', 'telegram_bot', 'max_bot', 'sms'] as const;

export type ChannelSectionId = (typeof channelSectionIds)[number];

export interface ChannelSection {
  id: ChannelSectionId;
  label: string;
  lead: string;
  configured: (form: ChannelDirectoryData) => boolean;
  Panel: ComponentType<ChannelPanelProps>;
}

export const channelSectionRegistry: readonly ChannelSection[] = [
  {
    id: 'telegram_client',
    label: 'Telegram Client',
    lead: 'Прямой Telegram-аккаунт клиники для живой связи. Это контактный канал, не массовый notify-flow.',
    configured: (form) => form.telegram_client_configured,
    Panel: TelegramClientPanel,
  },
  {
    id: 'telegram_bot',
    label: 'Telegram Bot',
    lead: 'Ссылка на notify-бота клиники для пациентов и сотрудников.',
    configured: (form) => form.telegram_bot_configured,
    Panel: TelegramBotPanel,
  },
  {
    id: 'max_bot',
    label: 'MAX Bot',
    lead: 'Поле принимает bot id или полную ссылку, ниже всегда показана итоговая ссылка.',
    configured: (form) => form.max_configured,
    Panel: MaxBotPanel,
  },
  {
    id: 'sms',
    label: 'SMS',
    lead: 'Исходящие SMS клиники. Токены и секреты на этой странице не меняются.',
    configured: (form) => form.sms_enabled || !!form.sms_tel_line,
    Panel: SmsChannelPanel,
  },
];

export function findChannelSection(id: ChannelSectionId): ChannelSection {
  return channelSectionRegistry.find((section) => section.id === id) ?? channelSectionRegistry[0];
}
